var map = {
	"./back-page-arrow.svg": 35730,
	"./character/avatars/avatar-1.svg": 26923,
	"./character/avatars/avatar-10.svg": 26001,
	"./character/avatars/avatar-11.svg": 85440,
	"./character/avatars/avatar-12.svg": 76179,
	"./character/avatars/avatar-13.svg": 45602,
	"./character/avatars/avatar-14.svg": 54893,
	"./character/avatars/avatar-15.svg": 19436,
	"./character/avatars/avatar-16.svg": 98463,
	"./character/avatars/avatar-17.svg": 60526,
	"./character/avatars/avatar-18.svg": 71081,
	"./character/avatars/avatar-2.svg": 92536,
	"./character/avatars/avatar-3.svg": 96777,
	"./character/avatars/avatar-4.svg": 67334,
	"./character/avatars/avatar-5.svg": 65367,
	"./character/avatars/avatar-6.svg": 38596,
	"./character/avatars/avatar-7.svg": 89765,
	"./character/avatars/avatar-8.svg": 28770,
	"./character/avatars/avatar-9.svg": 50291,
	"./character/avatars/character-icon.svg": 69011,
	"./character/bottom-bar/education.svg": 88521,
	"./character/bottom-bar/home.svg": 41080,
	"./character/bottom-bar/life-dashboard.svg": 30960,
	"./character/bottom-bar/setting.svg": 86891,
	"./character/bottom-bar/shop.svg": 22389,
	"./character/bottom-bar/skill.svg": 4472,
	"./character/bottom-bar/work.svg": 52946,
	"./character/button/active-point-background-1.svg": 66048,
	"./character/button/active-point-background-2.svg": 56787,
	"./character/button/bank-background.svg": 53185,
	"./character/top-bar/money.svg": 74445,
	"./character/top-bar/power.svg": 70130,
	"./character/top-bar/smile.svg": 79693,
	"./character/top-bar/time.svg": 63732,
	"./complete-education.svg": 90987,
	"./create-character/close_modal.svg": 40802,
	"./create-character/close_modal_black.svg": 2286,
	"./create-character/edit.svg": 65768,
	"./create-character/female.svg": 3700,
	"./create-character/man.svg": 73816,
	"./create-character/performance/curiosity.svg": 69340,
	"./create-character/performance/gratitude.svg": 62626,
	"./create-character/performance/grit.svg": 95937,
	"./create-character/performance/optimism.svg": 74751,
	"./create-character/performance/self-control.svg": 70595,
	"./create-character/performance/social-intelligence.svg": 71220,
	"./create-character/performance/zest.svg": 60419,
	"./create-character/progress1.svg": 18702,
	"./create-character/progress2.svg": 73082,
	"./create-character/progress3.svg": 68108,
	"./create-character/progress4.svg": 2003,
	"./create-character/smart/body.svg": 58878,
	"./create-character/smart/image.svg": 35041,
	"./create-character/smart/logic.svg": 61116,
	"./create-character/smart/music.svg": 64495,
	"./create-character/smart/nature.svg": 17203,
	"./create-character/smart/people.svg": 58743,
	"./create-character/smart/self.svg": 10888,
	"./create-character/smart/words.svg": 39801,
	"./education/close-modal.svg": 34950,
	"./education/complete-education.svg": 48694,
	"./education/degree-access.svg": 81497,
	"./education/phd-hard-pass.svg": 27362,
	"./education/phd-hard.svg": 29532,
	"./education/right-answer.svg": 70939,
	"./education/skill-down.svg": 31246,
	"./education/skill-equal.svg": 27818,
	"./education/skill-up.svg": 81445,
	"./education/wrong-answer.svg": 34816,
	"./log-in/error-lock.svg": 76698,
	"./log-in/lock.svg": 30933,
	"./main/bad-mood.svg": 2980,
	"./main/end-game.svg": 49961,
	"./main/facilitator-stopped.svg": 20787,
	"./main/good-mood.svg": 77492,
	"./main/neutral-mood.svg": 20772,
	"./reflection-answer.svg": 64531,
	"./shop/budget.svg": 64029,
	"./shop/economical.svg": 86682,
	"./shop/luxury.svg": 13105,
	"./slider/before-arrow.svg": 48070,
	"./slider/next-arrow.svg": 38244,
	"./tutorial/tooltip.svg": 94061,
	"./warn.svg": 56615,
	"./work/arrow-down.svg": 46007,
	"./work/career-tree-arrow.svg": 42082,
	"./work/house.svg": 8333,
	"./work/information-career.svg": 22498,
	"./work/negative-company-anchor.svg": 52330,
	"./work/no-work.svg": 33892,
	"./work/plane-table-open.svg": 14873,
	"./work/plane-table.svg": 31040,
	"./work/positive-company-anchor.svg": 63770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;